import { render, staticRenderFns } from "./EditWish2ActivityWishSlotDialog.vue?vue&type=template&id=f7464568&scoped=true"
import script from "./EditWish2ActivityWishSlotDialog.vue?vue&type=script&lang=js"
export * from "./EditWish2ActivityWishSlotDialog.vue?vue&type=script&lang=js"
import style0 from "./EditWish2ActivityWishSlotDialog.vue?vue&type=style&index=0&id=f7464568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7464568",
  null
  
)

export default component.exports